import { render } from "./popup.vue?vue&type=template&id=fa453156"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__